
import { AloDbUmbType } from '@/models/alodb/AloDbUmbType'
import { FilterBase } from '@/models/filter/FilterBase'

export interface IUmbTypeState {
    status:string
    umbTypes: Array<AloDbUmbType>
    modifiedAdmUmbType: AloDbUmbType
    originalAdmUmbType: AloDbUmbType
    umbTypeLoading: boolean
    adminFilter: FilterBase
}
  
const state:IUmbTypeState = { 
    status: '',
    umbTypes: [],
    modifiedAdmUmbType: new AloDbUmbType(),
    originalAdmUmbType: new AloDbUmbType(),
    umbTypeLoading:false,
    adminFilter: new FilterBase()
}
  
export default state